
    <app-titulo [modulo]="titulo"></app-titulo>
    <div class="row d-flex justify-content-center">
      <div class="card col-md-3 mt-4">
        <div class="card-header">
          <h6 class="list-group-item azul-titulos text-center">Administrar Usuarios</h6>
        </div>
        <ul class="list-group list-group-flush cursor">
          <li class="list-group-item" routerLink="/usuarios">
            <i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Consultar usuarios
          <li class="list-group-item" routerLink="/usuarios/cons-func-rol-usu">
            <i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Consultar  roles asignados a un usuario
          <li class="list-group-item d-flex" routerLink="/usuarios/asig-func-rol-usu">
            <i class="text-primary fa-solid fa-circle-chevron-right me-2 mt-3"></i> Asignación de aplicaciones y roles a usuarios
          </li> </ul>
      </div>

      <div class="card col-md-3 mt-4 ms-5">
        <div class="card-header">
                <h6 class="list-group-item azul-titulos text-center">Administración de roles</h6>
            </div>
            <ul class="list-group list-group-flush cursor">
                <li class="list-group-item" routerLink="/roles"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Consultar, editar y crear roles</li>
                <li class="list-group-item" routerLink="/roles/asig-rol-usu"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Asignación masiva de usuarios a roles</li>
                <li class="list-group-item" routerLink="/roles/cons-rol-func-usu"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Consultar roles asignados a usuarios</li>
            </ul>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="card col-md-3 mt-4 ">
            <div class="card-header">
                <h6 class="list-group-item azul-titulos text-center">Administrar aplicaciones</h6>
            </div>
            <ul class="list-group list-group-flush cursor">
                <li class="list-group-item" routerLink="/funcionalidades"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Consultar y editar aplicaciones</li>
                <li class="list-group-item" routerLink="/funcionalidades/crear-funcionalidad"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Crear nueva aplicación</li>
            </ul>
        </div>
        <div class="card col-md-3 mt-4 ms-5">
            <div class="card-header">
                <h6 class="list-group-item azul-titulos text-center">Autogestión</h6>
            </div>
            <ul class="list-group list-group-flush cursor">
                <li class="list-group-item" routerLink="/usuarios/registro-acciones"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Consultar registro de acciones</li>
                <li class="list-group-item" (click)="salir()"><i class="text-primary fa-solid fa-circle-chevron-right me-2"></i>Cerrar sesión</li>
            </ul>
        </div>
    </div>

